import { mutateApi } from "src/utils/api/ApiMethods"

export const toggleOnReaderTipSetting = ({ data }) => {
  return mutateApi({
    url: "hardware/toggle_on_reader_tipping",
    method: "PATCH",
    data,
  })
}

export const toggleAdvancedReceiptsSetting = ({ data }) => {
  return mutateApi({
    url: "hardware/toggle_advanced_receipts",
    method: "PATCH",
    data,
  })
}
